
const courseIndex = () => import("@/views/course-module/index.vue");
const courseDetail = () => import("@/views/course-module/detail.vue");

let router = [{
    path: '/course/index',
    name: 'courseIndex',
    component: courseIndex,
    meta: {
      title: '教程'
    }
  },
  {
    path: '/course/detail',
    name: 'courseDetail',
    component: courseDetail,
    meta: {
      title: '教程详情'
    }
  }
]
export default router



// WEBPACK FOOTER //
// ./src/router/course/index.js